<script>
import appConfig from '@/app.config'

import { notificationMethods } from '@/state/helpers'
import { refreshPageMixin } from '@/mixins/refresh-page.mixin'

export default {
  name: 'app',
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate (title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    }
  },
  mixins: [refreshPageMixin],
  mounted () {
    this.checkVersion('/version.json')
    this.initVersionCheck('/version.json')
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route (to, from) {
      // clear alert on location change
      this.clearNotification()
    }
  },
  methods: {
    clearNotification: notificationMethods.clear
  }
}
</script>

<template>
  <div id="app">
    <RouterView :key="$route.fullPath" />
    <div
      class="refresh-container"
      v-if="hashChanged && $root.env !== 'development' && modalOpen"
    >
      <div class="notification-header">
        <b-btn
          variant="icon"
          class="close-refresh-modal"
          @click="closeVersionModal()"
          ><i class="fas fa-times"></i
        ></b-btn>
      </div>
      <div class="notification-body">
        <div class="notification-button">
          <p class="h6">New Version Available</p>
          <p class="text-left font-size-12">
            An update is available. Please save all current work and click
            update below. You can also accept these updates by refreshing your
            browswer at any time.
          </p>
          <p class="text-left">
            <span class="font-size-12">Not updating may result in errors.</span>
          </p>
        </div>
        <div class="refresh-button text-center">
          <b-btn @click="reloadApp" variant="primary">Update</b-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.refresh-container {
  width: 15%;
  position: fixed;
  bottom: 10px;
  right: 15px;
  background-color: white;
  padding: 25px;
  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.05);
}
.close-refresh-modal {
  position: absolute;
  right: 5px;
  top: 5px;
  border: none;
}
</style>
